import { NuevoObjResponsable, ContactoSitio } from '../pages/sitios/models'

/**
 * @description Transforma objetos de snake_case a camelCase
 *
 * @author luis.durazo, Hábil MX
 * @version 1.0.0, 15/11/2022
 * @param o Objeto en snake_case
 * @returns Objeto transformado a camelCase
 */
export const keysToCamel = (o: any): any => {
  if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
    const n: any = {}
    Object.keys(o).forEach((k) => {
      n[toCamel(k)] = keysToCamel(o[k])
    })
    return n
  } else if (Array.isArray(o)) {
    return o.map((i) => {
      return keysToCamel(i)
    })
  }
  return o
}

export const keysToSnake = (o: any): any => {
  if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
    const n: any = {}
    Object.keys(o).forEach((k) => {
      n[toSnake(k)] = keysToSnake(o[k])
    })
    return n
  } else if (Array.isArray(o)) {
    return o.map((i) => {
      return keysToSnake(i)
    })
  }
  return o
}

/**
 * @description Transforma cadenas de snake_case a camelCase
 *
 * @author luis.durazo, Hábil MX
 * @version 1.0.0, 15/11/2022
 * @param s Cadena en snake_case
 * @returns Cadena transformado a camelCase
 */
export const toCamel = (s: string): string => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

/**
 * @description Transforma cadenas de camelCase a snake_case
 *
 * @author luis.durazo, Hábil MX
 * @version 1.0.0, 15/11/2022
 * @param s Cadena en camelCase
 * @returns Cadena transformado a snake_case
 */
export const toSnake = (s: string): string => {
  return s
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .split(' ')
    .join('_')
    .toLowerCase()
}

/**
 * @description Función que transforma un objeto de objetos en un arreglo de objetos
 *
 * @author sergio.guerrero, Hábil MX
 * @version 1.0.0, 14/03/2023
 *
 * @param obj objeto que se quiere transformar
 * @returns un arreglo con los valores del objeto de entrada
 */
export const objetoToArreglo = (obj: NuevoObjResponsable): ContactoSitio[] => {
  return Object.values(obj).map((value) => {
    return {
      ...value,
      telefono: value.telefono ? value.telefono : null,
      ausente: value.ausente,
      estatus: value.estatus,
    }
  })
}

/**
 * @description Funcion que transforma un arreglo en un objeto
 *
 * @author sergio.guerrero, Hábil MX
 * @version 1.0.0, 10/03/2023
 *
 * @param arr Arreglo que se desea convertir
 * @returns
 */
export const arregloToObjeto = (arr: ContactoSitio[]): NuevoObjResponsable => {
  return arr
    .map((contacto, i) => ({
      [i + 1]: {
        ...contacto,
        nivel: contacto.nivel || '1',
        telefono: contacto.telefono || null,
        ausente: contacto.ausente,
        estatus: contacto.estatus,
      },
    }))
    .reduce((prev, current) => ({ ...prev, ...current }), {})
}
